import List from './components/List'
import Show from './components/Show'
import SubmissionHome from './components/wizard/Home'
import SubmissionContents from './components/wizard/Content'
import SubmissionAuthors from './components/wizard/Author'
import SubmissionConfirmation from './components/wizard/Confirmation'

export default [
  {path: '/submission', component: List, name: 'submission.index'},
  {path: '/submission/:id/show', component: Show, name: 'submission.show'},
  {path: '/submission/home', component: SubmissionHome, name: 'submission.home', props: true},
  {path: '/submission/contents', component: SubmissionContents, name: 'submission.contents', props: true},
  {path: '/submission/authors', component: SubmissionAuthors, name: 'submission.authors', props: true},
  {path: '/submission/confirmation', component: SubmissionConfirmation, name: 'submission.confirmation', props: true}
]
